module.exports = __webpack_public_path__ + "img/L_JC.7e861a0e.png";